import { LogoutIcon } from './Icons';
import { Modal } from './Modal';

type LogoutConfirmationModalProps = {
  open: boolean;
  isSigningOut: boolean;
  accountName?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
};

export function LogoutConfirmationModal({
  open,
  isSigningOut,
  accountName,
  onCancel,
  onConfirm,
}: LogoutConfirmationModalProps) {
  return (
    <Modal
      open={open}
      title="Confirm logout"
      description="Your current session will end on this device."
      onClose={isSigningOut ? () => undefined : onCancel}>
      <div className="logout-confirmation">
        <div className="logout-confirmation-message">
          <div className="logout-confirmation-icon" aria-hidden="true">
            <LogoutIcon size={24} />
          </div>
          <div>
            <strong>Are you sure you want to log out?</strong>
            <p>
              {accountName
                ? `You are currently signed in as ${accountName}.`
                : 'You will need to sign in again to continue.'}
            </p>
          </div>
        </div>

        <div className="logout-confirmation-note">
          Unsaved form changes on this page may be lost. Your saved account data will not be removed.
        </div>

        <div className="logout-confirmation-actions">
          <button className="secondary-button" type="button" onClick={onCancel} disabled={isSigningOut}>
            Stay signed in
          </button>
          <button className="danger-button" type="button" onClick={onConfirm} disabled={isSigningOut}>
            <LogoutIcon size={17} />
            {isSigningOut ? 'Logging out...' : 'Confirm logout'}
          </button>
        </div>
      </div>
    </Modal>
  );
}
